import omit from 'lodash/omit';
import { CSSProperties } from 'react';
import { QuizCssStyleProperties, QuizStyles } from 'types';

export const getCssStylesFromQuizSettings = (quizStyles?: QuizStyles): QuizCssStyleProperties => {
    const slideCustomFontStyles: CSSProperties = {
        ...quizStyles?.fontStyles
    };

    const slideCustomBackgroundStyles: CSSProperties = {
        backgroundImage: quizStyles?.backgroundStyles?.backgroundImageUrl
            ? `url("${quizStyles?.backgroundStyles?.backgroundImageUrl}")`
            : undefined,
        ...omit(quizStyles?.backgroundStyles, 'backgroundImageUrl')
    };

    const customTitlePageStyles: CSSProperties = {
        backgroundImage: quizStyles?.titlePageStyles?.backgroundImageUrl
            ? `url("${quizStyles?.titlePageStyles?.backgroundImageUrl}")`
            : undefined,
        ...omit(quizStyles?.titlePageStyles, 'title', 'backgroundImageUrl')
    };
    const customTitleStyles: CSSProperties = {
        ...quizStyles?.titlePageStyles?.title
    };

    return {
        slideCustomFontStyles,
        slideCustomBackgroundStyles,
        customTitlePageStyles,
        customTitleStyles
    };
};

export const generateRandomColor = (): string => {
    const color = '#' + Math.floor(Math.random() * 16777215).toString(16);
    if(/^#[0-9A-F]{6}$/i.test(color)) {
        return color;
    }
    return generateRandomColor();
};
